import confetti from 'canvas-confetti';

let colors = ['#0066FF', '#6B4DE6', '#22C55E', '#F59E0B', '#EC4899', '#06B6D4'];

export const confetti_fire = () => {
  confetti({particleCount: 120, spread: 80, startVelocity: 45,
    origin: {y: 0.7}, colors, disableForReducedMotion: true});
  return {};
};